export default __webpack_public_path__ + "static/media/Group 11800.a2a5c587.svg";